import React from "react";
import clsx from "clsx";
import { StyledQueueAnim } from "./index.styled";
import { TableProps } from "antd";

type AppTableContainerProps = TableProps<any> & {
  columns: any;
  pagination?: false;
  hoverColor?: boolean;
  className?: string;
  rowKey?: string;
};

const AppTableContainer: React.FC<AppTableContainerProps> = ({
  columns,
  dataSource,
  pagination = false,
  hoverColor,
  className,
  rowKey,
  ...rest
}) => {
  return (
    <StyledQueueAnim
      className={clsx({ hoverColor: hoverColor }, className)}
      columns={columns}
      dataSource={dataSource}
      rowKey={rowKey || "id"}
      pagination={pagination}
      {...rest}
    />
  );
};

export default AppTableContainer;
